export var hexToRgb = function (hex) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result
        ? [
            parseInt(result[1], 16),
            parseInt(result[2], 16),
            parseInt(result[3], 16),
        ]
        : undefined;
};
export var rgbToHex = function (color) {
    if (!color) {
        return;
    }
    var red = color[0], green = color[1], blue = color[2];
    var rgb = blue | (green << 8) | (red << 16);
    return '#' + (0x1000000 + rgb).toString(16).slice(1);
};
export var normalizedRgbToHex = function (color) {
    if (!color) {
        return;
    }
    var red = color[0], green = color[1], blue = color[2];
    return rgbToHex([red * 255, green * 255, blue * 255]);
};
//# sourceMappingURL=color.js.map